import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

import Calculate from '../utils/calculator'
import { stat } from 'fs';

const step = 0.1
const precision = 2


const initialState = {
  location: {
    value:'United States',
    options: [
      { value: 'variable', label: 'typed' },
    ],
    placeholder: "Select...",
    label: "Country"
  },
  availability: {
    value: 345,
    min: 1,
    max: 365,
    step:1,
    precision: 0,
    unit:'days',
    label: "Operational days"
  },
  availabilityPercent: {
    value: 0,
    unit: '%',
    min: 0,
    max: 100,
    precision:1,
    label: "Utilization rate",
    component: "Result",
  },
  material: {
    value:'Copper',
    options: [
      { value: 'variable', label: 'typed' },
    ],
    placeholder: "Select...",
    label: "Metal"
  },
  materialPrize: {
    value: 0,
    unit: '$/tonne',
    precision:0,
    label: "Price per tonne metal"
  },
  throughput: {
    value: 3750,
    unit: 'dry tonnes/h',
    min: 0,
    precision: 0,
    label: "Feed rate"
  },
  headGrade: {
    value: 0.47,
    unit: '%',
    min: 0,
    max: 100,
    step: 0.01,
    precision:4,
    label: "Head grade"
  },
  recovery: {
    value: 86.6,
    unit: '%',
    min: 0,
    max:100,
    step,
    precision:1,
    label: "Current recovery"
  },

  launderType: {
    value: 'other',
    options: [
      { value: 'other', label: 'Peripherical, radials or other' },
      { value: 'center', label: 'Center launder' },
    ],
    label: "Existing launder configuration today"
  },

  cellSize: {
    value: '300',
    options: [
      { value: 'variable', label: 'typed' },
    ],
    placeholder: "Select...",
    unit: 'm³',
    label: "Volume in m³"
  },
  cellsPerLine: {
    value: 6,
    min: 1,
    max:12,
    step:1,
    label: "Number of cells per rougher line"
  },
  linesParallel: {
    value: 2,
    min: 1,
    max:12,
    step:1,
    label: "Number of roughers in parallel"
  },

  expectedShift: {
    value: 0.75,
    unit: '%',
    min: 0,
    max:100,
    step:0.01,
    precision: 2,
    label: "Expected Shift Recovery"
  },

  treatmentCharges: {
    value: 4,
    unit: '%',
    min: 0,
    max: 100,
    step:0.1,
    precision: 1,
    label: "Treatment & refining charges"
  },
  concentratorPower: {
    value: 0,
    unit: 'kWh/tonne',
    min: 0,
    max:1000,
    step:1,
    precision: 0,
    label: "Concentrator plant power consumption"
  },
  energyCost: {
    value: 0.08,
    unit: '$/kWh',
    min: 0,
    max:2,
    step:0.001,
    precision: 3,
    label: "Electricity cost"
  },

  opTime: {
    value: 0,
    unit: 'h',
    precision:0,
    label: "Yearly operation time",
    component: "Result",
  },
  recoveryPerY: {
    value: 0,
    unit: 'tonnes/annum',
    precision:0,
    label: "Amount Recovered per year",
    component: "Result",
  },
  cellsInCircuit: {
    value: 0,
    precision:0,
    label: "Total number of cells in rougher / scavanger circuit",
    component: "Result",
  },
  proposedNumCellsInLine: {
    value: 0,
    precision:0,
    label: "Proposed number of cell upgraded per line",
    component: "Result",
  },
  proposedNumCellsTotal: {
    value: 0,
    precision:0,
    label: "Total number of cells upgraded with Froth Management",
    component: "Result",
  },

  newRecovery: {
    value: 0,
    precision:4,
    label: "Recovery %",
    unit: '%',
    component: "Result",
  },
  newRecoveryPerY: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "Amount recovered per year",
    component: "Result",
  },
  newExtraRecovery: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "Extra Tonnes Recovered with Froth Management",
    component: "Result",
  },

  blowerPowerBefore: {
    value: 0,
    precision:0,
    unit: 'kW/h',
    label: "Estimated Power of Cells Before Upgrade",
    component: "Result",
  },
  blowerPowerAfter: {
    value: 0,
    precision:1,
    unit: 'kW/h',
    label: "Power of upgraded Cells",
    component: "Result",
  },
  blowerPowerSaved: {
    value: 0,
    precision:0,
    unit: 'kW/h',
    label: "Blower Power Saved",
    component: "Result",
  },
  blowerPowerSavedAnnual: {
    value: 0,
    precision:0,
    unit: 'MWh/annum',
    label: "Blower Annual Power Savings",
    component: "Result",
  },
  blowerCO2SavedAnnual: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "Blower Annual CO"+String.fromCharCode(8322)+" Savings",
    component: "Result",
  },  
  extraTonnesAnnual: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "Extra recovered with Froth Management",
    component: "Result",
  },
  powerSavedAnnualKwh: {
    value: 0,
    precision:0,
    unit: 'kWh/annum',
    label: "Power saved due to extra recovery",
    component: "Result",
  },
  powerSavedAnnualMwh: {
    value: 0,
    precision:0,
    unit: 'MWh/annum',
    label: "Power saved due to extra recovery",
    component: "Result",
  },
  co2SavedAnnual: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "CO"+String.fromCharCode(8322)+" avoided due to extra recovery",
    component: "Result",
  },

  cashIncrease: {
    value: 0,
    precision:0,
    unit: '$/annum',
    label: "Increased cash from recovery improvement",
    component: "Result",
  },
  costSavings: {
    value: 0,
    precision:0,
    unit: '$',
    label: "Cost saving Concentrator's power savings due to improved recovery + blower power saving",
    component: "Result",
  },
  powerTotalSavedAnnual: {
    value: 0,
    precision:0,
    unit: 'MWh/annum',
    label: "Power saved with Froth Management",
    component: "Result",
  },
  co2TotalSavedAnnual: {
    value: 0,
    precision:0,
    unit: 'tonnes/annum',
    label: "CO"+String.fromCharCode(8322)+" reduction with Froth Management",
    component: "Result",
  },
  co2FootPrint: {
    value: 0,
    precision:0,
    unit: 'tonnes',
    label: "Project total CO"+String.fromCharCode(8322)+" foot print",
    component: "Result",
  },
  co2Payback: {
    value: 0,
    precision:0,
    unit: 'months',
    label: "Months to net zero CO"+String.fromCharCode(8322)+" foot print",
    component: "Result",
  },

  conversionFactor: {
    value: 0,
    precision:0,
    label: "Utility Conversion Factor",
    component: "Result",
  },

  co2factors:[
    {country:"init",factor:0}
  ],
  energyConsumptions:[
    {metal:"init",consumption:0},
  ],
  cellSizes:[
    {name:"init",volume:0,powerPerCell:0.0,blowerPortion:0,blowerSaving:0,co2ToCL:0.0},
  ]

};

export const calcSlice = createSlice({
  name: 'calc',
  initialState,
  reducers: {
    setValue: (state, action: PayloadAction<{ name: string, value: any }>) => {
      // @ts-ignore
      state[action.payload.name].value = action.payload.value
      if(action.payload.name === 'launderType') {
        if(action.payload.value === 'other') {
          state.expectedShift.value = 0.75
        } else {
          state.expectedShift.value = 0.5
        }
      }

      return Calculate(state,action.payload.name)

    },
    setCountries: (state, action: PayloadAction<{ countries: any }>) => {
      state.co2factors = action.payload.countries
      const countryList = action.payload.countries.map( (item:any, index:number) => {
        return {value:item.country, label:item.country, key:index}
      })
      state.location.options = countryList
      return Calculate(state,'location')
    },
    setEnergyConsumptions: (state, action: PayloadAction<{ energyConsumptions: any }>) => {
      state.energyConsumptions = action.payload.energyConsumptions
      const metalList = action.payload.energyConsumptions.map( (item:any, index:number) => {
        return {value:item.metal, label:item.metal, key:index}
      })
      state.material.options = metalList
      return Calculate(state,'material')
    },
    setCellSizes: (state, action: PayloadAction<{ cellSizes: any }>) => {
      state.cellSizes = action.payload.cellSizes
      const cellList = action.payload.cellSizes.map( (item:any, index:number) => {
        return {value:item.volume.toString(), label:item.name, key:index}
      })
      state.cellSize.options = cellList
      return Calculate(state,'cellSize')
    },
  },
});

export const calcActions = calcSlice.actions;

export const selectProperty = (property: string) => (state: RootState) => {
  if (state.calc.hasOwnProperty(property)) {
    // @ts-ignore
    return state.calc[property]
  }
  return undefined
}

export const getLocationStatus = () => (state: RootState) => {
  if(state.calc.location.value) {
    return true
  }
  return false
}

export const getProcessStatus = () => (state: RootState) => {
  if(state.calc.material.value && state.calc.throughput.value && state.calc.headGrade.value && state.calc.recovery.value) {
    return true
  }
  return false
}

export const getOperationStatus = () => (state: RootState) => {
  if(state.calc.cellSize.value !=='0' && state.calc.cellsPerLine.value && state.calc.linesParallel.value) {
    return true
  }
  return false
}

export const getUtilizationStatus = () => (state: RootState) => {
  if(state.calc.availability.value) {
    return true
  }
  return false
}

export const getCostsStatus = () => (state: RootState) => {
  if(state.calc.materialPrize.value && state.calc.treatmentCharges.value && state.calc.concentratorPower.value && state.calc.energyCost.value) {
    return true
  }
  return false
}

export const getValueStatus = () => (state: RootState) => {
  if(state.calc.expectedShift.value) {
    return true
  }
  return false
}

export const getPdfStatus = () => (state: RootState) => {
  if(
    state.calc.location.value &&
    state.calc.material.value && state.calc.throughput.value && state.calc.headGrade.value && state.calc.recovery.value && 
    state.calc.cellSize.value !=='0' && state.calc.cellsPerLine.value && state.calc.linesParallel.value && 
    state.calc.availability.value &&
    state.calc.materialPrize.value && state.calc.treatmentCharges.value && state.calc.concentratorPower.value && state.calc.energyCost.value &&
    state.calc.expectedShift.value
    ) {
    return false
  }
  return true
}

export const getEqualValues = () => (state: RootState):{[key:string]:number} => {
  if(state.calc.co2TotalSavedAnnual.value > 0) {
    const co2Value = state.calc.co2TotalSavedAnnual.value
    return {'cars':co2Value/4.75, 'trees':co2Value/0.039, 'planes':co2Value/0.231}
  }
  return  {'cars':0, 'trees':0, 'planes':0}
}

export const printCalculation = () => (state: RootState):any => {
  return state.calc
}

export default calcSlice.reducer;